<template>
  <div>
    <img alt="loading img" class="img-fluid" src="../../assets/img/loading.gif">
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "Spinner",
  props: {},
  data(){
    return{}
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}

}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/Spinner.vue